angular.module('core')
    .directive('dblTopicStandardSwitch', [function() {

    return {
        restrict: 'E',
        scope: {
            dblCustomerId: '=',
            dblSchoolId: '=',
            dblClassroomId: '=',
            dblTopicStandardChoice: '='
        },
        templateUrl: '/resources/core/directives/topic-standard-switch/dbl-topic-standard-switch.directive.html',
        controller: [
            '$q',
            '$scope',
            'authentication',
            'edxAcademicMappingsApi',
            'profileApi',
            function (
                $q,
                $scope,
                authentication,
                edxAcademicMappingsApi,
                profileApi)
        {
            var academicStandardShortDescs = {};

            $scope.activeAstName = null;
            $scope.program = null;

          /**
           * Get an academic standard short description
           *
           * @param astName AST name
           * @returns {*} AST short description, if known, otherwise AST name
           */
            function getAstShortDesc(astName) {
                if (academicStandardShortDescs[astName]) {
                    return academicStandardShortDescs[astName];
                } else {
                    return astName;
                }
            }

            function _initialize() {
                $scope.isLoading = true;
                _loadData().finally(function () {
                    $scope.isLoading = false;
                });
            }

          /**
           * Load all data needed to display AST switch
           *
           * @returns {*} Promise which resolves when all data is loaded
           * @private
           */
            function _loadData() {
                return $q.all([
                    _loadActiveAcademicStandard(),
                    _loadActiveAcademicProgram(),
                    _loadAcademicMappingTitles()
                ]);
            }

          /**
           * Load the academic program which should be used
           *
           * @returns {*} Promise which resolves when active academic program is loaded
           * @private
           */
            function _loadActiveAcademicProgram() {
                return profileApi.getCustomerSetting($scope.dblCustomerId, $scope.dblSchoolId, $scope.dblClassroomId, profileApi.ACADEMIC_PROGRAM).then(function(response){
                    $scope.program = response.value;
                });
            }

          /**
           * Load the academic standard which should be used
           *
           * @returns {*} Promise which resolves when active academic standard is loaded
           * @private
           */
            function _loadActiveAcademicStandard() {
                var astNameDeferred = $q.defer();

                // Currently we can pull this directly off of the customer info
                // that has already been loaded. In the future maybe it lives in Edex settings.
                var customer = authentication.getCustomer();
                astNameDeferred.resolve(customer.academic_standard_name);
                $scope.activeAstName = customer.academic_standard_name;

                return astNameDeferred.promise;
            }

          /**
           * Load mappings from program name to program title
           *
           * @returns {*} Promise which resolves when mappings are loaded
           * @private
           */
            function _loadAcademicMappingTitles() {
                return edxAcademicMappingsApi.getAcademicMappings().then(function(response){
                    if (_.isArray(response)) {
                        _.forEach(response, function(ast){
                            academicStandardShortDescs[ast.name] = ast.shortDesc;
                        });
                    }
                });
            }

            $scope.getAstShortDesc = getAstShortDesc;

            _initialize();
        }]
    };
}]);
